import { createFileRoute } from '@tanstack/react-router';
import { StockCountsRegister } from '../../../../features/silo-counts/components/StockCountsRegister';

/** Stock count register (BUILD_SPEC.md §8.6). PageHeader lives inside
 * StockCountsRegister itself (guidance-wave gap, 2026-08-26) — see that
 * component's doc comment for why. */
export const Route = createFileRoute('/_authenticated/silo-counts/counts/')({
  component: StockCountsRegister,
});
